module.exports = __webpack_public_path__ + "img/3875366_s.046b48c0.jpg";